/**
 * Created by alex.y on 9/22/2017.
 */

export class FeeTotal{
    public Total: number;
    public Date: Date;
}


// WEBPACK FOOTER //
// ./app/objects/report/feeTotal.ts